import { ApiErrorCodes } from "@/Modules/App/Models/Api/ApiErrorCodes";

import { updateEmail } from "@/Services/TherapyApi/OnBoardingFunctional";

import useUserStore from "@/Modules/User/Store";
import useOnboardingStore from "@/Modules/OnBoarding/Store";

import { danger } from "@/Utils/Debug";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";

async function updateEmailAH(email: string): Promise<void> {
  const userStore = useUserStore();
  const onBoardingStore = useOnboardingStore();

  onBoardingStore.hasErrorInProcess = false;
  onBoardingStore.errorCode = null;
  onBoardingStore.isLoading = true;

  try {
    await updateEmail({ email });

    onBoardingStore.setNextStep(null);

    await userStore.setUser();
  } catch (err: unknown) {
    const code = isApiError(err) ? err["error_code"] : null;

    if (code === ApiErrorCodes.SAME_EMAIL) {
      onBoardingStore.errorCode = ApiErrorCodes.SAME_EMAIL;
    } else if (code === ApiErrorCodes.EMAIL_ALREADY_EXIST) {
      onBoardingStore.errorCode = ApiErrorCodes.EMAIL_ALREADY_EXIST;
    }

    danger(code);

    onBoardingStore.hasErrorInProcess = true;
  } finally {
    onBoardingStore.isLoading = false;
  }
}

export default updateEmailAH;
